import * as React from "react";
import styles from "@/components/Layouts/TopNavbar/Notification.module.css";
import {
	IconButton,
	Button,
	Typography,
	Tooltip,
	Menu,
	Link,
	Badge,
} from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { useChatSocket } from "@/contexts/ChatSocketContext";

const Notification = () => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const { notificationCount } = useChatSocket() || {};
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	return (
		<>
			<Tooltip title='Notificari'>
                    <Link href="/notificari">
                         <IconButton
                              onClick={handleClick}
                              size='small'
                              sx={{
                                   backgroundColor: "transparent !important",
                                   width: "40px",
                                   height: "40px",
                                   p: 0,
                            
                              }}
                              aria-controls={open ? "account-menu" : undefined}
                              aria-haspopup='true'
                              aria-expanded={open ? "true" : undefined}
                              className='ml-2 for-dark-notification'
                         >
                              <Badge badgeContent={notificationCount} color='error' max={99} invisible={!notificationCount}>
                                   <NotificationsActiveIcon color='#fff' />
                              </Badge>
                         </IconButton>
                    </Link>
			</Tooltip>

			
		</>
	);
};

export default Notification;
